<script setup>
import DmarcMessaging from '@/Common/Classifiers/DmarcDirectiveMessaging.js';
import ExplainDirective from '@/Pages/DomainAnalysis/Partials/ExplainDirective.vue';

defineProps({
  title: String,
  directive: Object
});
</script>

<template>
  <ExplainDirective
    :classifier="DmarcMessaging"
    :title="title"
    :directive="directive"
  />
</template>
